import { Injectable } from '@angular/core';
import { HttpClientService } from '../implementacion/http-client.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ObjDel } from 'src/app/models/SiicartAdm/ObjDel.model';


@Injectable({ providedIn: 'root' })
  export class usuarioService {

    constructor( private http: HttpClientService ) { }

    ObtenerUsuarios() {
      return this.http.get(`${environment.apiScar}Usuarios/ObtenerUsuarios`)
        .pipe(map(response => response));
    }
    AgrModfUsuario(usuario: any) {
      return this.http.post(`${environment.apiScar}Usuarios/AgregarModificaUsuario`, usuario)
        .pipe(map(response => response));
    }

    EliminarUsuario(ids: ObjDel) {
      return this.http.post(`${environment.apiScar}Usuarios/EliminarUsuarios`, ids)
      .pipe(map(response => response));
    }

    updatePass(idUs: string, pass: string){
      return this.http.post(`${environment.apiScar}Usuarios/updatepassword`, {pass:pass, id:idUs});
    }

    validarToken(token: string) {
      return this.http.post(`${environment.apiScar}TokenReset/validation`, {token: token})
    }

}